export default __webpack_public_path__ + "assets/img/authentication-layout.e2868ed.jpg";